<script setup>
import DOMPurify from 'dompurify';

const props = defineProps(['value']);
</script>

<template>
  <div class="w-full text-left pl-2 font-medium" v-html="DOMPurify.sanitize(props.value.label)" />
</template>
